import {TitlesActions, TitlesActionTypes} from "../actions/titles.actions";


export interface TitlesState {
  titles:Array<any>
}

export const initialState: TitlesState = {
  titles: []
};

export function titleReducer(state = initialState, action: TitlesActions): TitlesState {
  switch (action.type) {
    case TitlesActionTypes.TitlesLoaded:
      return {...state,titles:action.titles}
    default:
      return state;
  }
}
